// extracted by mini-css-extract-plugin
export default {"banner3":"banner_banner3__jO8fk","banner_wrapper":"banner_banner_wrapper__PfUM-","heading":"banner_heading__m2xGO"};